<template>
  <div>
    <GChart type="ComboChart" :data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import MoveHelper from "@/utils/move-helper";

export default {
  name: "MoveChart",

  props: ["match", "moves"],

  data() {
    return {};
  },

  computed: {
    fullMoveCount() {
      return MoveHelper.fullMoveCount(this.moves, this.blackToStart);
    },

    whiteMoves() {
      return MoveHelper.whiteMoves(this.match, this.moves, this.blackToStart);
    },

    blackMoves() {
      return MoveHelper.blackMoves(this.match, this.moves, this.blackToStart);
    },

    chartData() {
      return [
        [
          "Move nubmer",
          "White move",
          "Black move",
          "White buffer",
          "Black buffer",
          "White Offset",
          "Black Offset",
        ],
        ...Array(this.fullMoveCount)
          .fill()
          .map((_, i) => [
            i + 1,
            this.whiteMoves[i] ? this.whiteMoves[i].moveTime : 0,
            this.blackMoves[i] ? this.blackMoves[i].moveTime : 0,
            this.whiteMoves[i] ? this.whiteMoves[i].bufferTime : 0,
            this.blackMoves[i] ? this.blackMoves[i].bufferTime : 0,
            this.whiteMoves[i] ? this.whiteMoves[i].timeOffset : 0,
            this.blackMoves[i] ? this.blackMoves[i].timeOffset : 0,
          ]),
      ];
    },

    chartOptions() {
      return {
        // title: "Company Performance",
        // subtitle: "Sales, Expenses, and Profit: 2014-2017",
        height: 500,
        chartArea: {
          width: "85%",
          height: "85%",
        },
        legend: { position: "bottom", maxLines: 3 },
        // bar: { groupWidth: "73" },
        // isStacked: true,
        seriesType: "line",
        series: {
          0: { type: "bars", targetAxisIndex: 0 },
          1: { type: "bars", targetAxisIndex: 0 },
          2: { type: "line", targetAxisIndex: 0 },
          3: { type: "line", targetAxisIndex: 0 },
          4: { type: "line", targetAxisIndex: 1 },
          5: { type: "line", targetAxisIndex: 1 },
        },
        vAxis: {
          title: "Move Time",
          minorGridlines: {
            color: "transparent",
          },
        },
        vAxes: {
          0: {
            title: "Move Time",
          },
          1: {
            title: "Offsets",
            minValue:
              Math.min(
                ...this.whiteMoves.map((m) => m.timeOffset),
                ...this.blackMoves.map((m) => m.timeOffset)
              ) - 2,
          },
        },
        explorer: {
          axis: "horizontal",
          keepInBounds: true,
          maxZoomIn: this.moves.length / 15,
          maxZoomOut: 1.0,
        },
        // focusTarget: "category",
      };
    },
  },
};
</script>

<style></style>
